import { render, staticRenderFns } from "./PepperGreenExtract.vue?vue&type=template&id=8dcd489a&scoped=true&"
import script from "./PepperGreenExtract.vue?vue&type=script&lang=js&"
export * from "./PepperGreenExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcd489a",
  null
  
)

export default component.exports